import type { CalculationResults } from "../calculator/result";

class Format {
    number = new Intl.NumberFormat('nl-NL')

    Dash = (value: any) => {
        if (value === null) {
            return '-'
        }
        return value;
    }

    Duration = (duration: number | null): (string | null) => {
        if (duration === null) {
            return null
        }

        const hours = Math.floor(duration/3600).toString().padStart(2, "0")
        const minutes = Math.floor((duration%3600)/60).toString().padStart(2, "0")
        const seconds = Math.floor(duration%60).toString().padStart(2, "0")

        return `${hours}:${minutes}:${seconds}`
    }

    Number = (value: number | null | undefined, zero: string = '/', precision: number = 0) => {
        if (value == 0 || value === null || value === undefined) {
            return zero
        }
        const mul = Math.pow(10, precision)
        value = Math.round(value * mul) / mul

        return this.number.format(value)
    }

    Outcome = (value: number, results?: CalculationResults | null) => {
        if (results === undefined || results === null) {
            return "/"
        }

        const result = Math.round(value / (results.outcome.attackers + results.outcome.defenders + results.outcome.draw))
        return result > 0 ? this.Percent(result) : '/'
    }

    Percent = (value: number, zero: string = '/', precision: number = 0) => {
        return (value == 0) ? zero : this.Number(value * 100, zero, precision) + "%";
    }
}

export default new Format()